

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';

@Component({
  name: 'DateRangePicker',
})
export default class extends Vue {
  @Prop({ default: [] }) value!: string[];
  @Prop({ default: null }) allowedDates!: (val: string) => boolean;
  private dates: string[] = [];

  get eventColor() {
    return `primary ${
      this.$vuetify.theme.dark ? 'darken-2' : 'lighten-2'
    } date-in-range `;
  }

  created() {
    this.dates = this.value;
  }

  @Watch('value')
  onValueChanged(val: string[]) {
    this.dates = val;
  }

  @Watch('value')
  onLocaleChanged(val: string[]) {
    this.dates = val;
  }

  private diff<T>(a: Array<T>, b: Array<T>) {
    return a.filter(v => !b.includes(v));
  }

  private onInput(val: string[]) {
    let newRange: string[];
    if (val.length > 2) {
      let newDate = this.diff(val, this.dates)[0];
      let currentRange = this.dates.sort();
      newRange = [currentRange[0], newDate];
    } else if (val.length == 1) {
      newRange = [val[0], val[0]];
    } else {
      newRange = val;
    }
    this.dates = newRange.sort();
    this.$emit('input', this.dates);
  }

  private selectedRange(date: string) {
    if (this.dates.length == 2) {
      return date > this.dates[0] && date < this.dates[1];
    }
  }
}
